import React from 'react';
import PageHero from '../components/layout/PageHero';
import HevEnergyManagementSimulator from '../components/tools/HevEnergyManagementSimulator';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';

const HevEnergyManagementSimulatorPage = () => (
  <div className="min-h-screen" data-testid="hev-energy-management-page">
    <PageHero
      eyebrow="Engineering Utilities"
      title="HEV Energy Management Simulator"
      description="Drive a full hybrid through a drive cycle with a rule-based controller and with ECMS, keep the battery charge-sustaining, and see the fuel, CO₂ and engine operating points each strategy produces against the same car without its hybrid system."
      testId="hev-energy-management-hero"
    />
    <section className="py-12 md:py-16">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
        <Alert data-testid="hev-assumptions-note">
          <Info className="h-4 w-4" />
          <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Assumptions</AlertTitle>
          <AlertDescription>
            Quasi-static and backward-facing: the cycle's speed trace is followed exactly, one step per
            second, on a flat road. The engine is always warm (no cold start or warm-up), engine dynamics
            are ignored, the gearbox follows a fixed shift schedule, and there is no emissions
            after-treatment. The fuel map is US EPA benchmark data for a Toyota 2.5 L engine, scaled to
            your engine size. It is an <strong>engineering approximation</strong> for comparing strategies,
            not any manufacturer&apos;s calibration. See the User Guide&apos;s Assumptions &amp; Limitations section.
          </AlertDescription>
        </Alert>
        <HevEnergyManagementSimulator />
        <ToolGuideCta guidePath="/simulation/hev-energy-management/guide" toolName="HEV Energy Management Simulator" />
      </div>
    </section>
  </div>
);

export default HevEnergyManagementSimulatorPage;
